import Tabs, { TabList } from '@atlaskit/tabs';
import { css } from '@compiled/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactElement } from 'react';

import { sendUIEvent } from 'src/utils/analytics';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';

import { CustomTab } from './CustomTab';

export const MY_LEARNING_TAB_PATHS = ['on-demand', 'live-training', 'certifications'];

export const MyLearningTabs = (): ReactElement => {
  const { user } = useAtlassianUser();
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab from current URL
  const activeTabIndex = MY_LEARNING_TAB_PATHS.findIndex((path) => location.pathname.includes(path));

  const handleTabChange = (index: number): void => {
    const targetPath = MY_LEARNING_TAB_PATHS[index];

    navigate(`/my-learning/${targetPath}`);

    user &&
      sendUIEvent(
        'myLearningScreen',
        'tab',
        'clicked',
        'myLearningTab',
        {
          learningTab: targetPath,
        },
        user.account_id,
      );
  };

  return (
    <div css={tabsListContainerStyles} data-testid="my-learning-tabs">
      <Tabs onChange={handleTabChange} id="default" selected={activeTabIndex >= 0 ? activeTabIndex : 0}>
        <TabList>
          <CustomTab label="On-demand" />
          <CustomTab label="Live training" />
          <CustomTab label="Certifications" />
        </TabList>
      </Tabs>
    </div>
  );
};

const tabsListContainerStyles = css({
  marginTop: '28px',
});
